const translateStyleObjToReactStyleObj = styleObj => {
  // Not using default value in the args in
  // order to also handle null
  styleObj = styleObj || {};
  const result = Object.entries(styleObj).reduce((previous, _ref) => {
    let [selectorName, selectorRules] = _ref;
    // Not using default value in the destruct in
    // order to also handle null
    selectorRules = selectorRules || {};
    const styleRulesStr = Object.entries(selectorRules).reduce((prev, curr) => {
      return {
        ...prev,
        ...convertCssToReactCss(curr)
      };
    }, {});
    return {
      ...previous,
      [selectorName]: styleRulesStr
    };
  }, {});
  return result;
};

/**
 * Borrowed from here: https://github.com/jacobbuck/css-to-style/blob/e56ca57fad60ed9d29cb91a5f6a95b050b29483a/src/index.js#L2
 * @param str
 * @returns string
 */
const camelCase = str => str.replace(/-(\w|$)/g, (m, p1) => p1.toUpperCase());
const convertCssToReactCss = cssProp => {
  const [styleProp, value] = cssProp;
  const reactStyleProp = camelCase(styleProp);
  return {
    [reactStyleProp]: value
  };
};
export default translateStyleObjToReactStyleObj;
//# sourceMappingURL=index.js.map